import { Field, Input, Switch } from "../ds";
import type { SWidget } from "./model";

/** General visual settings every type shares: visibility, lock and the accessible name. */
export function WidgetGeneral({ widget, onChange, multi }: { widget: SWidget; onChange: (patch: Partial<SWidget>, key?: string) => void; /** Several visuals selected: alt text is per visual, so it is not offered. */ multi?: boolean }) {
  return (
    <details className="st-general" open={!!(widget.hidden || widget.locked || widget.altText) || undefined}>
      <summary>General: visibility, lock, alt text</summary>
      <div className="st-general__body">
        <Switch label="Hide from viewers and TVs" checked={!!widget.hidden} onChange={(v) => onChange({ hidden: v })} />
        <Switch label="Lock position and size (designer only)" checked={!!widget.locked} onChange={(v) => onChange({ locked: v })} />
        {multi ? null : <Field label="Alt text" hint="Read aloud by screen readers for this visual. Describe what it shows, e.g. 'Revenue by month, rising since March'.">
          <Input inputSize="sm" value={widget.altText ?? ""} maxLength={300} onChange={(e) => onChange({ altText: e.target.value || undefined }, `alt-${widget.id}`)} aria-label="Alt text" />
        </Field>}
      </div>
    </details>
  );
}
